// useSharedWithMeQuery — threads created for you via a share (GET /sessions/shared-with-me).
// Same one-off createApiClient() pattern as useDeleteThread/useUpdateTitle (see
// those files) rather than the DI ThreadsApiClient, which only covers
// create/list/detail today.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import { threadKeys } from './queryKeys';
import { toThreadSummaryList } from './toThreadView';
import type { ThreadSummaryView } from './types';

const DEFAULT_LIMIT = 50;

function getClient() {
  return createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  });
}

export function useSharedWithMeQuery(
  limit: number = DEFAULT_LIMIT,
): UseQueryResult<ReadonlyArray<ThreadSummaryView>> {
  return useQuery<ReadonlyArray<ThreadSummaryView>>({
    queryKey: threadKeys.sharedWithMe(limit),
    queryFn: async ({ signal }) => {
      const raw = await getClient().request({
        path: '/api/v1/sessions/shared-with-me',
        query: { limit },
        signal,
      });
      return toThreadSummaryList(raw);
    },
  });
}
